import {type ReactNode} from "react";

interface PanelProps {
    children: ReactNode,
    title?: string,
}

export function Panel({
                          children,
                      }: PanelProps) {
    return (
        <div className="algoliaAutocompletePanel">
            <div className="algoliaAutocompletePanel__body">{children}</div>
        </div>
    );
}